<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="dedf" style="font-style: normal;"><a class="page" id="pv"></a>FOR ALEX AND NICHOLAS</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chi-Leong-0005.vue?410c4470